import classNames from "classnames";
import moment from "moment";

import { useEffect, useRef, useState } from "react";
import styles from "./styles.module.scss";
import { FC, Props } from "./typings";

import Avatar from "components/Avatar";
import { decryptPackage } from "utils/decryptPackage";
import { getUserId } from "utils/getUserId";
import { useAuth } from "react-oidc-context";
import ChatMessageAttachment from "components/ChatMessageAttachment";
import ChatMessageOptions from "components/ChatMessageOptions";
import ChatMessageAttachToDossierModal from "components/ChatMessageAttachToDossierModal";
import HtmlWithImages from "components/HtmlWithImages";
import { EStatus } from "components/Avatar/typings";
import { useTranslation } from "react-i18next";

const ChatMessage: FC<Props> = ({
  handleChangePackages, // eslint-disable-line @typescript-eslint/no-unused-vars
  editMode = false, // eslint-disable-line @typescript-eslint/no-unused-vars
  isSelected = false,
  Package: pack,
  statuses, // eslint-disable-line @typescript-eslint/no-unused-vars
  tags, // eslint-disable-line @typescript-eslint/no-unused-vars
  keys,
  refetch, // eslint-disable-line @typescript-eslint/no-unused-vars
  onDownload,
  onPreview,
  index, // eslint-disable-line @typescript-eslint/no-unused-vars
  setPack,
  encryptionKeyId,
  isLast,
  participants,
}) => {
  const { t } = useTranslation();
  const auth = useAuth();
  const refWrapper = useRef<HTMLDivElement>(null);
  const [showOptions, setShowOptions] = useState(false);
  const [showDossier, setShowDossier] = useState(false);



  const [content, setContent] = useState("");

  const userId = getUserId(auth.user!);

  const getContent = async () => {
    // typy wiadomości szyfrowanych
    // todo: isEncrypted w IPackage
    if (encryptionKeyId) {
      try {
        if (!keys) {
          return;
        }

        const encryptionKey = keys.find((key) => key?.Id === encryptionKeyId);

        let parentKey = null;
        if (encryptionKey?.ParentKeyId) {
          parentKey = keys.find(
            (key) => key?.Id === encryptionKey?.ParentKeyId
          );
        }

        setContent(
          await decryptPackage(userId, pack.Content, encryptionKey, parentKey)
        );
        return;
      } catch (e) {
        setContent(t("chat.decryptionError"));
        return;
      }
    } else {
      setContent(t("chat.noKey"));
    }
  };

  const handleAddToDossierClick = () => {
    setShowDossier(true);
  };

  useEffect(() => {
    getContent();
  }, [pack, isSelected, keys, encryptionKeyId]);

  useEffect(() => {
    if (isLast && refWrapper?.current) {
      refWrapper.current.scrollIntoView();
    }
  }, [content]);

  // useEffect(() => {
  //   const t = tags?.filter((tag) =>
  //     pack?.TagIds?.find((iTag) => tag.Id === iTag)
  //   );

  //   const newStatus = statuses?.find((s) => s.Id === pack.StatusId);
  //   setFindedTags(t);

  //   setStatus(newStatus ?? null);
  // }, [statuses, pack.StatusId]);

  const refWrappeer = useRef();

  return (
    <>
      <div
        key={pack.Id}
        ref={refWrapper}
        className={classNames(
          styles.wrapper,
          !pack.Incoming && styles.outgoing
        )}
        // onMouseEnter={() => setShowOptions(true)}
        // onMouseLeave={() => setShowOptions(false)}
      >
        {pack.Incoming && (
          <div className={styles.avatar}>
            <Avatar
              name={pack.SenderLabel}
              size="small"
              status={
                participants.find(
                  (x) => x.UserId === pack.SenderId && x.IsOnline
                )
                  ? EStatus.ONLINE
                  : EStatus.OFFLINE
              }
            ></Avatar>
          </div>
        )}

        <div
          className={classNames(
            styles.card,
            styles.scrollable,
            styles.expanded
          )}
        >
          <div className={styles.header}>
            <div className={styles.rows}>
              <div onClick={() => {}} className={styles.row1}>
                <div className={styles.sender}>{pack?.SenderLabel}</div>
                <div className={styles.date}>
                  {moment(pack?.CreationDate)
                    .format("HH:mm DD.MM.YYYY")
                    .toString()}
                </div>
                <ChatMessageOptions
                  message={pack}
                  showOptions={showOptions}
                  toggle={() => setShowOptions(false)}
                  refWrapper={refWrappeer}
                ></ChatMessageOptions>
              </div>
            </div>
          </div>

          <div className={styles.body}>
            {
              <>
                <div
                  className={styles.lead}
                  onClick={() => {
                    if (setPack) return;
                  }}
                >
                  <HtmlWithImages htmlString={content}></HtmlWithImages>
                </div>
                <div className={styles.attachments}>
                  {pack.Attachments?.map((attachment) => (
                    <div className={styles.attach}>
                      <ChatMessageAttachment
                        key={"att_" + attachment.Id}
                        onAddDossier={handleAddToDossierClick}
                        date={moment(pack.CreationDate)
                          .format("HH:MM | DD.MM.YYYY")
                          .toString()}
                        onNewWindow={() => {}}
                        onPreview={(attach) => {
                          onPreview(pack, attach);
                        }}
                        onDownload={(attach) => onDownload(pack, attach)}
                        attachment={attachment}
                      />
                    </div>
                  ))}
                </div>
              </>
            }
          </div>
        </div>
      </div>

      {showDossier && (
        <ChatMessageAttachToDossierModal
          message={pack}
          toggle={() => setShowDossier(false)}
          encryptionKeyId={encryptionKeyId}
          refetch={() => {}}
        ></ChatMessageAttachToDossierModal>
      )}
    </>
  );
};

export default ChatMessage;
